var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"modal",on:{"hidden":_vm.doNothing,"hide":_vm.doNothing,"ok":_vm.doNothing,"shown":_vm.doNothing}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fa60327","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/custom/mbstalas/dialogs/modalLoader.vue
// module id = 1269
// module chunks = 146